import { render } from "./productlistheader.vue?vue&type=template&id=ea27882c"
import script from "./productlistheader.vue?vue&type=script&lang=js"
export * from "./productlistheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__